export default function AutomacaoSection() {
  return (
    <section className="ai-section" id="metodo">
      <div className="ai-fade-top" aria-hidden="true" />
      <div className="ai-fade-bottom" aria-hidden="true" />
      <div className="ai-container">
        <div className="ai-media">
          <video
            src="/automacao.webm"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="ai-video ai-video--zoom ai-video--invert"
          />
        </div>
        <div className="ai-copy">
          <span className="faq-tag">Método</span>
          <h2 className="ai-title">
            Resultado não é sorte.
          </h2>
          <p className="ai-text">
            Pegamos uma operação que recebia visita, mas não vendia. Reestruturamos a jornada inteira: anúncio, página e checkout. É isso que fazemos com empresas que precisam acelerar: diagnóstico, estratégia, execução e resultado.
          </p>
        </div>
      </div>
    </section>
  );
}
